import { Box, Card, CardContent, Chip, Container, Grid, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { BG_LIGHT } from '../theme'

interface RelatedItem {
    headline: string
    body: string
    link: string
    tag: string
}

interface RelatedSolutionsSectionProps {
    title?: string
    subtitle?: string
    items: RelatedItem[]
    color: string
}

export function RelatedSolutionsSection({
    title = 'As you grow, explore',
    subtitle = "The platform grows with you. Here's where most clients head next.",
    items,
    color,
}: RelatedSolutionsSectionProps) {
    return (
        <Box sx={{ backgroundColor: BG_LIGHT, py: { xs: 6, md: 10 } }}>
            <Container maxWidth="lg">
                <Typography variant="h3" sx={{ textAlign: 'center', mb: 2 }}>{title}</Typography>
                <Typography color="text.secondary" sx={{ textAlign: 'center', mb: 6 }}>{subtitle}</Typography>
                <Grid container spacing={4} justifyContent="center">
                    {items.map(item => (
                        <Grid item xs={12} md={5} key={item.headline}>
                            <Card
                                component={Link}
                                to={item.link}
                                variant="outlined"
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    textDecoration: 'none',
                                    borderColor: `${color}20`,
                                    transition: 'border-color 0.2s, box-shadow 0.2s',
                                    '&:hover': { borderColor: color, boxShadow: `0 4px 20px ${color}20` },
                                }}
                            >
                                <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <Chip label={item.tag} size="small" sx={{
                                        alignSelf: 'flex-start', mb: 2,
                                        backgroundColor: `${color}10`, color: color,
                                        fontWeight: 600, fontSize: '11px',
                                    }} />
                                    <Typography variant="h5" sx={{ mb: 1.5 }}>{item.headline}</Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8, flex: 1 }}>
                                        {item.body}
                                    </Typography>
                                    <Box sx={{
                                        mt: 3, display: 'inline-flex', alignItems: 'center', gap: 0.5,
                                        color: color, fontSize: '13px', fontWeight: 600,
                                    }}>
                                        Explore this solution <ArrowForwardIcon sx={{ fontSize: 14 }} />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    )
}
